import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { bonuses } from "../../data/landing";
export function BonusesSection() {
  return <Section tone="sand" cta="I want all 5 bonuses" data-id="element-79" data-mp="qdirbuoqgcmj">
      <div className="flex justify-center" data-id="element-80" data-mp="qetwnyxttsfr">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-rose text-white" data-id="element-81" data-mp="vb0qwugv1fhv">
          <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-82" data-mp="1j14ux2xynh9e" />
        </span>
      </div>
      <SectionHeading eyebrow="Exclusive bonuses — included free" title={<>
            Today, you'll also receive <em className="text-rose" data-id="element-84" data-mp="19atmp478ulwp">5 professional bonuses</em>
          </>} subtitle={<>
            Combined value: <s data-id="element-85" data-mp="1e8bpsdyky6ws">$197</s> — <strong className="text-cta" data-id="element-86" data-mp="220isduuwfa4n">Included FREE today.</strong>
          </>} data-id="element-83" data-mp="1o10zb3aklaph" />

      <div className="mx-auto mt-12 max-w-3xl space-y-8" data-id="element-87" data-mp="26qz85lm6z7u6">
        {bonuses.map(b => <article key={b.number} className="-mx-5 overflow-hidden bg-white shadow-[0_1px_2px_rgba(23,33,63,0.06)] sm:mx-0 sm:rounded-3xl" data-id="element-88" data-mp="2m5ideh77878g">
            <div className="relative" data-id="element-89" data-mp="2h88p54vjq1m7">
              <img src={b.image} alt={`${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-90" data-mp="2vv20y05uwp9n" />
              <span className="absolute left-4 top-4 rounded-full bg-ink px-3.5 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-91" data-mp="2r421oo99lv3z">
                Bonus #{b.number}
              </span>
            </div>
            <div className="p-6 md:p-8" data-id="element-92" data-mp="2zxox2d9k8wcn">
              <div className="flex flex-wrap items-center gap-2" data-id="element-93" data-mp="2zyzxq47plnzj">
                <span className="text-sm font-semibold text-inkSoft" data-id="element-94" data-mp="3et4p6cqkyi6e">
                  Value: <s data-id="element-95" data-mp="39ujo6b3i7ugw">${b.value}</s>
                </span>
                <span className="rounded-full bg-cta/10 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-ctaDark" data-id="element-96" data-mp="39t07wkhuljf4">
                  Free today
                </span>
              </div>
              <h3 className="mt-2 font-serif text-2xl font-bold leading-tight text-ink md:text-3xl" data-id="element-97" data-mp="1fj52c5dm6f6f">{b.title}</h3>
              <div className="mt-3 space-y-3 text-[16px] leading-relaxed text-inkSoft" data-id="element-98" data-mp="296t0fs03pujv">
                {b.body.map(p => <p key={p} data-id="element-99" data-mp="2e5cl7p2yl0an">{p}</p>)}
              </div>
              {b.list && <ul className="mt-4 space-y-2" data-id="element-100" data-mp="2j58rxw31j5tw">
                  {b.list.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-101" data-mp="2o4lf6hxtqex0">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-102" data-mp="2s559ldr0j4fg" />
                      {item}
                    </li>)}
                </ul>}
              {b.closing && <p className="mt-5 rounded-xl bg-sand p-4 text-[16px] font-semibold leading-relaxed text-ink" data-id="element-103" data-mp="31uymci2w5pla">{b.closing}</p>}
            </div>
          </article>)}
      </div>
    </Section>;
}